import { createConfig, http } from 'wagmi';
import { coinbaseWallet, injected, walletConnect } from 'wagmi/connectors';

import { RPC_POLLING_INTERVAL, WALLETCONNECT_PROJECT_ID } from './lib/consts';
import { sankoMainnet, sankoTestnet } from './chains';

console.log('Environment variables:', {
  REACT_APP_VERCEL_ENV: process.env.REACT_APP_VERCEL_ENV,
  NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
  VERCEL_ENV: process.env.VERCEL_ENV,
  NODE_ENV: process.env.NODE_ENV,
});

const chains =
  process.env.REACT_APP_VERCEL_ENV === 'production' ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ||
  process.env.VERCEL_ENV === 'production'
    ? ([sankoMainnet] as const)
    : ([sankoTestnet] as const);

console.log('Selected chains:', chains);

export const config = createConfig({
  chains,
  connectors: [
    injected({
      shimDisconnect: true,
    }),
    // coinbaseWallet({
    //   appName: 'Sanko© Dream Machine',
    //   headlessMode: true
    // }),
    walletConnect({
      projectId: WALLETCONNECT_PROJECT_ID,
      metadata: {
        name: '¡Sanko!',
        description: '¡Sanko! Lovable Blockchain Cart Game',
        url: typeof window !== 'undefined' ? window.location.origin : '',
        icons:
          typeof window !== 'undefined'
            ? [`${window.location.origin}/splash_screens/icon.png`]
            : [],
      },
      showQrModal: false,
    }),
  ],
  transports: {
    [sankoMainnet.id]: http(undefined, {
      batch: true,
    }),
    [sankoTestnet.id]: http(undefined, {
      batch: true,
    }),
  },
});
